import React, { useState, useLayoutEffect, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth, startOfDay, endOfDay, addDays } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { DataGrid } from '@mui/x-data-grid';
import { Column } from '@ant-design/plots';
import { Spin } from "antd"
import StorageService from "../../utils/storage.service";
import "./scss/report.scss"
import 'antd/dist/antd.min.css'
import { Tooltip } from "antd";

const ReportLocation = () => {
    const [title, setTitle] = useState("Doanh số theo chi nhánh")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [receipt, setReceipt] = useState({})
    const [receiptByCash, setReceiptByCash] = useState(0)
    const [receiptByCredit, setReceiptByCredit] = useState(0)
    const [paySwipeCard, setPaySwipeCard] = useState(0)
    const [payCardMoney, setPayCardMoney] = useState(0)
    const [payLoyalty, setPayLoyalty] = useState(0)
    const [payOther, setPayOther] = useState({})
    const [dataChart, setDataChart] = useState([])
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const history = useHistory();
    const [generalData, setGeneralData] = useState(null)
    const [typeBHVV, setTypeBHVV] = useState(0)
    const [store, setStore] = useState(
    (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
        (JSON.parse(StorageService.getItem("user_info")).stores[0]?.id).toString()
    : StorageService.getItem("currentStore").toString())

    let currentUrl = window.location.pathname
    if (currentUrl.includes('report/locations') && [3].includes(userAdmin.role)) history.push('/report/daily');

    const handleStore = useCallback((e) => {
        setStore(e.toString())
    }, [store])
    
    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }

    const columns = [
        { field: 'store_name', headerName: 'Chi nhánh', width: 200, cellClassName: (params) => "text4" },
        { field: 'totalOrder', headerName: 'Tổng đơn hàng', type: "number", width: 140, styles: { color: "red" } },
        {
            field: 'revenue',
            headerName: 'Tổng tiền đã thu',
            type: "number",
            description:'Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, không bao gồm sử dụng thẻ tiền và điểm tích lũy. ( Tổng tiền đã thu = tiền thu (nguồn Online) + Tiền thu (nguồn KTV) + Nợ đã thu ).',
            valueGetter: (params) => convertCurrency(params.row.revenue), width: 170,
            cellClassName: (params) => "text1",
        },
        {
            field: 'revenueNoTax',
            headerName: 'Tổng thực thu bán hàng',
            description: 'Tổng tiền đã thu sau khi loại trừ VAT 8%',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.revenueNoTax),
            width: 170,
            cellClassName: () => "text7",
        },
        {
            field: 'owed',
            headerName: 'Còn nợ',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.owed), width: 130,
            cellClassName: (params) => "text2"
        },
        {
            field: 'revenueOwe',
            headerName: 'Nợ đã thu',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.revenueOwe), width: 140,
            cellClassName: (params) => "text1"
        },
        {
            field: 'totalReceiptThuan',
            headerName: 'Tiền phải thu',
            description: 'Tiền phải thu = Doanh số thuần + VAT',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.totalReceiptThuan), width: 150,
            cellClassName: (params) => "text7"
        },
        {
            field: 'totalNoTax',
            headerName: 'Doanh số thuần',
            description: 'Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh thu - Giảm giá - VAT)',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.totalNoTax), width: 150,
            cellClassName: (params) => "text7"
        },
        {
            field: 'deposit',
            headerName: 'Trừ tài khoản',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.deposit), width: 130,
            cellClassName: (params) => "text2"
        },
        {
            field: 'giftCashTotal',
            headerName: 'Trừ điểm tích luỹ',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.giftCashTotal ?? 0), width: 120,
            cellClassName: (params) => "text3"
        },
        {
            field: 'voucher',
            headerName: 'Trừ voucher',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.voucher ?? 0), width: 130,
            cellClassName: (params) => "text2"
        }
    ];
    
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, startDate, endDate, typeBHVV)
    }, [store, endDate, startDate, typeBHVV])

    const fetchData = async (s, sD, eD, tB) => {
        let payload = {
            stores: s,
            startDate: sD,
            endDate: eD,
            type: tB
        }
        const rs = await axiosService(`api/reports/locations`, "POST", payload)
        const { data } = rs
        if (data.code === 200) {
            let { financialSummary, dataChart, dataByStore } = data.data
            setGeneralData(financialSummary)
            setDataChart(dataChart ?? [])
            setRows(dataByStore ?? [])

            setLoading(false)
        }
    }

    const config = {
        data: dataChart,
        xField: 'name',
        yField: 'value',
        xAxis: {
            label: {
                autoRotate: true,
            },
        },
        slider: {
            start: 0,
            end: 1,
        },
        minColumnWidth: 20,
        maxColumnWidth: 20,
        yAxis: {
            label: {
                formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        tooltip: {
            formatter: (data) => {
                return {
                    name: data.name,
                    value: convertCurrency(data.value)
                };
            },
        },
        color: 'red'
    };
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }

    return (
        <>
            <div className={`${styles.background} report-page container-fluid`}>
                <FilterReport startDate={startDate} endDate={endDate}
                    handleRangeDate={handleRangeDate}
                    store={store} handleStore={handleStore}
                    title={title} type={"locations"}
                    csvData={rows} isExport={isExport}
                    typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                    handleExportData={handleExportData}
                    header={
                        [
                            { label: 'Chi nhánh', key: "name" },
                            { label: "Số đơn hàng", key: "orders" },
                            { label: "Tổng tiền đã thu", key: "receipt" },
                            { label: "Trừ tài khoản", key: "deposit" },
                            { label: "Trừ điểm thưởng", key: "gift_cash" },
                            { label: "Trừ voucher", key: "voucher" },
                            { label: "Còn nợ", key: "owed" },
                            { label: "Nợ đã thu", key: "revenueOwe" },
                            { label: "Doanh thu", key: "revenue" }
                        ]
                    }
                    userAdmin={userAdmin}
                />
                <Spin spinning={loading}>
                    <Row className="pt-2">
                        <Col xs={12} md={5}>
                            <Row>
                                <Col xs={12} md={6}>
                                    <Tag color="blue" className="w-100 h-100 p-2">
                                        <div className={styles.textTag3}>
                                            <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, không bao gồm sử dụng thẻ tiền và điểm tích lũy. ( Tổng tiền đã thu = tiền thu (nguồn Online) + Tiền thu (nguồn KTV) + Nợ đã thu )'>
                                                Tổng tiền đã thu <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className="d-flex justify-content-end mb-2">
                                            <div className={`${styles.textTag} ml-3`}>
                                                {convertCurrency(generalData?.totalRevenue || 0)}
                                            </div>
                                        </div>
                                        <div className={styles.textTag3}>
                                            <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, không bao gồm sử dụng thẻ tiền và điểm tích lũy. ( Tổng tiền đã thu = tiền thu (nguồn Online) + Tiền thu (nguồn KTV) + Nợ đã thu )'>
                                                Tổng thực thu bán hàng <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className="d-flex justify-content-end mb-2">
                                            <div className={`${styles.textTag} ml-3`}>
                                                {convertCurrency(generalData?.totalRevenueNoTax || 0)}
                                            </div>
                                        </div>
                                        <div className={styles.textTag3}>
                                            <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh số - Giảm giá)'>
                                                Doanh số thuần <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </div>
                                        <div className="d-flex justify-content-end mb-2">
                                            <div className={`${styles.textTag} ml-3`}>
                                                {convertCurrency(generalData?.totalNetNoTax || 0)}
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Tag color="red" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>Tình Trạng Nợ</span>
                                        <div className="d-flex justify-content-between p-1">
                                            <div>
                                                <span className={styles.textTag4}>
                                                    <Tooltip title='Tổng giá trị hàng hóa, dịch vụ, sản phẩm mà khách hàng đã mua nhưng chưa thanh toán.'>
                                                        Còn Nợ <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                                </span>

                                                <span className={styles.textTag4}>
                                                    <Tooltip title='Tổng số tiền thu được từ "Tiền nợ".'>
                                                        Nợ đã thu <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                                </span>
                                            </div>
                                            <div className="text-right">
                                                <span className={styles.textTag}>{convertCurrency(generalData?.totalOwe || 0)}</span>
                                                <span className={styles.textTag}>{convertCurrency(generalData?.paidOwe || 0)}</span>
                                            </div>

                                        </div>
                                    </Tag>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col xs={12} md={6}>
                                    <Tag color="green" className="w-100 h-100 p-2">
                                        <span className={styles.textTag2}>Tiền thu các phương thức</span>
                                        <div className="d-flex justify-content-between p-1">
                                            <div>
                                                <span className={styles.textTag4}>Tiền mặt</span>
                                                <span className={styles.textTag4}>Chuyển khoản</span>
                                                <span className={styles.textTag4}>Quẹt thẻ</span>
                                            </div>
                                            <div className="text-right">
                                                <span className={styles.textTag}>{convertCurrency(generalData?.paidCash || 0)}</span>
                                                <span className={styles.textTag}>{convertCurrency(generalData?.paidBanking || 0)}</span>
                                                <span className={styles.textTag}>{convertCurrency(generalData?.paidCredit || 0)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Tag color="aquamarine" className={`${styles.tag1} w-100 h-100 p-2`}>
                                        <p className={styles.textTag2}>Khoản không tính thực thu</p>
                                        <div className="d-flex justify-content-between  p-1">
                                            <div>
                                                <p className={styles.textTag4}>Trừ tài khoản</p>
                                                <p className={styles.textTag4}>Trừ điểm tích luỹ</p>
                                                <p className={styles.textTag4}>Trừ voucher</p>
                                            </div>
                                            <div className="text-right">
                                                <p className={styles.textTag}>{convertCurrency(generalData?.paidCentWallet || 0)}</p>
                                                <p className={styles.textTag}>{convertCurrency(generalData?.paidLoyalty || 0)}</p>
                                                <p className={styles.textTag}>{convertCurrency(generalData?.voucherDiscount || 0)}</p>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                            </Row>
                            <Row className="pt-2 mt-2">
                                <Col xs={12} className="hide-mobile">
                                    <div className="mb-2">
                                        <Tooltip title='Chỉ số theo tiền đã thu.'>
                                            Biểu đồ <i className="fas fa-info-circle" ></i>
                                        </Tooltip>
                                    </div>
                                    <div style={{ backgroundColor: "white" }} className="p-2">
                                        <Column {...config} />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={7}>
                            <div style={{ backgroundColor: "white" }} className="p-2">
                                <div className="mb-2">
                                    <strong>Bảng dữ liệu chi tiết</strong>
                                </div>
                                <div style={{ height: 630, width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        rowsPerPageOptions={[6]}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Spin>
            </div>
        </>
    )
}
export default ReportLocation